import React, {useEffect, useState} from "react";
import {TelecastsData} from "../types";
import { getTelecastsLists } from "../../service";
import { CommonLists } from "../../components/list/common-lists";
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import {useLoading} from "../../components/loading/LoadingProvider";

function TelecastsLists(){

    const [lists,setLists] = useState<Array<TelecastsData>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();
    const loading = useLoading()

    useEffect(() =>{

        if(pageNum === 1){
            loading.showLoading()
        }
        getTelecastsLists({
            pageNum
        }).then(res => {
            if(res.code === 1){
                loading.hideLoading()
                const lists = res.data.list
                if((lists as Array<TelecastsData>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            }else{
                loading.showError('无法获取数据')
            }
        })
    },[pageNum])

    return <div className="telecasts">
        <CommonLists lists={ lists } path={'/home/telecast/@id/detail'}/>
        <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
    </div>
}

export default TelecastsLists
